import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingGptImageAiGeneratorConfig } from '@/data/landingConfig/landingGptImageAiGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_GptImageAiGenerator } from './schemaObject';

interface Props {}
const GptImageAiGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_GptImageAiGenerator} />
			<LandingTemplate
				data={landingGptImageAiGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default GptImageAiGenerator;
